import api from '../../plugins/api';

const uploadDocumentToDeal = ({ dealId, fileTypeId, file, statusId = 1, signed = false, onProgress }) => {
  const formData = new FormData();
  formData.append('dealId', dealId);
  formData.append('fileTypeId', fileTypeId);
  formData.append('file', file);
  formData.append('statusId', statusId);
  formData.append('signed', signed);

  return api.post('/api/crm/deals/uploadDocumentToDeal', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress: onProgress ? (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      onProgress({
        loaded: progressEvent.loaded,
        total: progressEvent.total,
        percent: percentCompleted
      });
    } : undefined
  });
};

export default uploadDocumentToDeal;